import { Injectable } from '@angular/core';
import { Api } from '../providers/api/api';
import { Usuario } from '../entities/usuario';
import { DTOInformacaoUsuario } from '../dto/dtoInfomacaoUsuario';
import { EmpresaUsuario } from '../entities/empresa-usuario';

@Injectable()
export class UsuarioDAO {
    constructor(private _api: Api) {   }



    public adicionarUsuario(usuario: Usuario): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.put('Usuario/AddUsuario', { usuario: usuario}).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });

    }
    /*
    public adicionarUsuario(usuario: Usuario): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.post('Usuario', usuario).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }
    */

    public recuperarSenhaUsuario(cpf: string, idEmpresa: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.get(`Usuario/RecuperarSenha/${cpf}/${idEmpresa}`).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }

    public alterarUsuario(usuario: Usuario): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.put('Usuario/AlterarUsuario', { usuario: usuario }).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }   

    public login(usuario: Usuario): Promise<DTOInformacaoUsuario> {
        return new Promise((resolve, reject) => {
            this._api.get(`Usuario/Autenticacao/${usuario.CpfUsuario}/${usuario.Senha}/${usuario.Empresa.Id}`).subscribe(res => {
                if (res)
                    resolve(new DTOInformacaoUsuario().deserialize(JSON.parse(res._body)));

                reject('Usuário ou senha incorretos.');
            }, error => {
                reject(error);
            });
        });
    }

    public obterEmpresaUsuario(pCNPJEmpresaUsuario: String,pEmpresa: number): Promise<EmpresaUsuario> {
        return new Promise((resolve, reject) => {
            this._api.get(`Usuario/ObterEmpresaUsuario/${pCNPJEmpresaUsuario}/${pEmpresa}`).subscribe(res => {
                if (res)
                resolve(new EmpresaUsuario().deserialize(JSON.parse(res._body)));
                //resolve(JSON.parse(res._body));

                reject('CNPJ não encontrado.');
            }, error => {
                reject(error);
            });
        });
    }

    public obterUsuarioDaEmpresa(idEmpresa: number): Promise<Usuario[]> {
        return new Promise((resolve, reject) => {
            let mecanicos: Usuario[] = [];

            this._api.get(`Usuario/Lista`).subscribe(res => {
                JSON.parse(res._body).forEach(element => {
                    mecanicos.push(new Usuario().deserialize(element));
                });

                resolve(mecanicos);
            }, error => {
                reject(error);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/daos/usuario-dao.ts